<template>
  <ul id="swiperContent">
    <li :class="{'swiper_active':data.id==resourceId}" v-for="(data,index) in resourceData"
        :key="data.id"
        class="swiper_list">
      <img :class="{'actives':data.id==resourceId}" @click="sendMsg(data)" :src="img" alt="" />
      <div @click="sendMsg(data)" class="swiper_items">
        <img v-if="data.type == 1" :src="picture" alt="" />
        <img v-if="data.type == 2" :src="doc" alt="" />
        <img v-if="data.type == 3" :src="audio" alt="" />
        <img v-if="data.type == 4" :src="video" alt="" />
        <img v-if="data.type == 5" :src="doc" alt="" />
        <img v-if="data.resourceType == 3" :src="doc" alt="" />
        <span>{{data.resourceType == 3 ? `任务`+(index+1) : data.name }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
import img from "./img/swiper.png";
import video from "../../../../static/images/sourceIcon/video.png";
import doc from "../../../../static/images/sourceIcon/file.png";
import audio from "../../../../static/images/sourceIcon/audio.png";
import picture from "../../../../static/images/sourceIcon/pic.png";
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
import {moduleId} from "../../../store/modules/courseDetail";
export default {
  data() {
    return {
      img: img,
      video: video,
      doc: doc,
      audio: audio,
      picture: picture,
      faceValue:null,
      list: [],
      showNext: true,
    };
  },
  // props:['swiperData','resourceId'],
    //   watch: {
    //       'resourceId':{
    //           handler(newValue) {
    //               this.faceValue = newValue;
    //           },
    //           deep: true
    //       }
    //   },
  computed:{
      ...mapState(moduleId, {
          resourceData: state => state.resourceData,
          swiperFlag:state => state.swiperFlag,
          resourceId:state => state.resourceId,
      }),
  },
  methods: {
      ...mapActions(moduleId,[
          "setSwiperFlag",
          "setCurrentResource",
          "setResourceId"
      ]),
    sendMsg(data) {
        this.setResourceId(data.id);
        this.setCurrentResource(data);
      // this.$emit("func", data);
      // this.$emit("getResourceId",id);
    }
  },
};
</script>
<style lang="scss" scoped>
#swiperContent {
  height: 100%;
  overflow: hidden;
  .actives{
    border:1px solid #5D99FF;
    visibility: hidden;
  }
  overflow-y: auto;
  .swiper_list {
    width: 160px;
    height: 90px !important;
    padding: 0;
    margin: 15px auto 0 !important;
    border-radius: 3px;
    background: url("./img/swiper1.png") no-repeat;
    background-size: 100%, 100%;
    position: relative;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
    .swiper_items {
      width: 100%;
      height: 30px;
      /*margin-top:35px;*/
      position: absolute;
      top: 35px;
      color: white;
      img {
        width: 32px;
        height: 32px;
        float: left;
        margin-left: 16px;
      }
      span {
        width: 100px;
        height: 25px;
        margin-left: 6px;
        margin-top: 5px;
        float: left;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

  }
  .swiper_active{
    color: #262628;
    border:1px solid #5D99FF;
  }
  .swiper-button-prev {
    position: absolute;
    top: 45px;
    left: 35%;
    width: 64px;
    height: 25px;
    background: rgba(0, 0, 0, 1);
    /*opacity:0.3;*/
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    line-height: 25px;
    i {
      color: white;
      font-size: 20px;
    }
  }
  .swiper-button-next {
    position: absolute;
    top: 500px;
    left: 35%;
    width: 64px;
    height: 25px;
    background: rgba(0, 0, 0, 1);
    /*opacity:0.3;*/
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    line-height: 25px;
    i {
      color: white;
      font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subcomponent/courseList/index.vue